import React from 'react';
import {Message} from '../';
import Spacer from '../common/spacer/Spacer';

const UserContentGated = () => {
    return (
        <Spacer className="container min-height" top={40}>
            <Message as="p" code="epic.esport.content_gate.title" />
            <Message as="p" code="epic.esport.content_gate.info" args={['/competitive/support']} />
        </Spacer>
    );
};

export default UserContentGated;
